import { Stack, Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { whenPrintingPageOnly, whenPrintingPlainBackground } from "../../../../../shared/components/print/printPageOnly"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { MeetingSection } from "../components/meetigs/MeetingSection"
import { GuestCheckInSection } from "../components/guestCheckIn/CheckInSection"
import { GuestsOverview } from "../components/guestsOverview/GuestsOverview"
import { HomePrintSection, hiddenWhenPrinting } from "../components/homePrintMode"

const useStyles = makeStyles()((theme) => ({
    container: {
        paddingTop: "3rem",
        backgroundColor: tailwindPalette.blue[50],
        ...whenPrintingPageOnly({
            paddingTop: 0,
        }),
        ...whenPrintingPlainBackground({
            backgroundColor: theme.palette.common.white,
        }),
    },
    sectionTitle: {
        fontWeight: "bold",
        fontSize: "1.25rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem",
    },
    sectionContent: {
        padding: "1rem 0",
        borderBottom: "1px solid #E5E7EB",
    },
    row: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "1rem",
    },
    noDataContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "6rem",
    },
    sideColumn: whenPrintingPageOnly({ display: "none" }),
    bookingsColumn: {
        display: "flex",
        flex: 1,
        ...hiddenWhenPrinting(HomePrintSection.GUEST_LIST),
    },
}))

export function ServiceCenterReportsHome() {
    const { classes } = useStyles()

    return (
        <Box className={classes.container}>
            <GuestsOverview />
            <Stack direction={{ xs: "column", md: "row" }} spacing="1.5rem">
                <Box className={classes.bookingsColumn}>
                    <MeetingSection />
                </Box>
                <Stack flex={1} spacing="1rem" className={classes.sideColumn}>
                    <GuestCheckInSection />
                    {/*<CheckInSection />*/} {/*todo temporary hide*/}
                    {/*<NewsSection />*/} {/*todo temporary hide*/}
                </Stack>
            </Stack>
        </Box>
    )
}
